import React from 'react';
import { comparisonRows } from '../data/atlasContent';
const costItems = ['€200–500 in verlorener Ernte', '€30–100 in falschen Düngemitteln', '6–8 Stunden Fehlersuche', 'Die Willenskraft, weiterzumachen'];
export function HiddenCosts() {
  return <section className="border-b border-line bg-canvas py-20 lg:py-28" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-48" data-mp="xxar6jfuwosa">
      <div className="mx-auto max-w-7xl px-6" data-id="element-49" data-mp="16wfndj3y461a">
        

        <div className="mt-12 grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-16" style={{
        marginTop: "0px",
        marginBottom: "0px",
        gap: "25px"
      }} data-id="element-50" data-mp="16v4ghaf7ei5y">
          <div className="overflow-hidden rounded-xl border border-line bg-surface shadow-md shadow-forest/10" data-id="element-51" data-mp="1glpd4sbbhcm8">
            <table className="w-full border-collapse text-left" data-id="element-52" data-mp="1bpqkutmvbagj">
              <caption className="sr-only" data-id="element-53" data-mp="1qlgcb7atofsn">Vergleich: Urban Farming ohne und mit Diagnose-Atlas</caption>
              <thead data-id="element-54" data-mp="1ln50ws4vpx8b">
                <tr className="bg-panel" data-id="element-55" data-mp="1ljh8xxf31ivp">
                  
                  
                  
                </tr>
              </thead>
              <tbody data-id="element-56" data-mp="1wwmx7epa5kpa">
                {comparisonRows.map(row => <tr key={row.label} className="border-t border-line" data-id="element-57" data-mp="1wz9194cypi2r">
                    
                    
                    
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div data-id="element-58" data-mp="25vgoqqnr7kvz">
            <h3 className="font-serif text-xl font-semibold text-forest" data-id="element-59" data-mp="2ax5z0435juj0">Eine einzelne Fehldiagnose kostet dich:</h3>
            <ul className="mt-5 space-y-3" data-id="element-60" data-mp="2fv7iur8ejxvj">
              {costItems.map(item => <li key={item} className="flex gap-3 text-base text-prose" data-id="element-61" data-mp="2kmpjtfafdygi">
                  <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-emerald" data-id="element-62" data-mp="2knircih7krzp" />
                  {item}
                </li>)}
            </ul>

            <p className="mt-8 text-base leading-relaxed text-prose" data-id="element-63" data-mp="2togrgpoj0fd0">
              Multipliziere das mit 3 Fehldiagnosen pro Jahr. Das sind{' '}
              <span className="font-semibold text-forest" data-id="element-64" data-mp="2yk5p2ngzjm6o">€990–2.700 verloren.</span>
            </p>

            <div className="mt-8 rounded-xl bg-mint-soft p-6 shadow-md shadow-forest/10" style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            marginTop: "15px",
            marginBottom: "15px"
          }} data-id="element-65" data-mp="yhwjrd4zw7u2">
              <p className="text-base leading-relaxed text-forest" data-id="element-66" data-mp="13iar0syrvdr1">
                Das Diagnose-Handbuch kostet <span className="font-mono" data-id="element-67" data-mp="1h9pa0zsojey3">€21</span> einmalig. Es spart dir{' '}
                <span className="font-mono" data-id="element-68" data-mp="1d9ojwhw7xfb7">€2.700+</span> pro Jahr.
              </p>
              <p className="mt-3 font-mono text-2xl font-semibold text-emerald" style={{
              marginTop: "0px",
              marginBottom: "0px"
            }} data-id="element-69" data-mp="1r8wpbsiz5jnu">ROI 11.250 %</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}